import { defineStore } from 'pinia'

const LOGGED_USER_ROLE = 'logged_user_role'
export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    role: localStorage.getItem(LOGGED_USER_ROLE),
  }),
  getters: {
    users: (state) => state.user
  },
  actions: {
    async login(email, password) {
      const response = await this.myApis.auth.signInApi(email, password)

      // TEMPORARY: CloudFront移行後に削除 (Token認証 → Cookie認証に戻す)
      // Store token in localStorage
      if (response.data.token) {
        localStorage.setItem('auth_token', response.data.token)
      }

      this.user = response.data.user
      this.setRole(response.data.user.role)
      if (response.data.user.role === 'admin') {
        return this.router.push('/admin/students')
      }
      if (response.data.user.role === 'teacher') {
        return this.router.push('/teacher/me')
      }
      this.router.push('/student/me')
    },
    async getAuthUser() {
      try {
        const response = await this.myApis.auth.getAuthUser()
        this.user = response.data
        this.setRole(response.data.role)
      } catch {
        this.setRole()
        this.user = null
      }
    },
    async logout() {
      await this.myApis.auth.logout()

      // TEMPORARY: CloudFront移行後に削除 (Token認証 → Cookie認証に戻す)
      // Remove token from localStorage
      localStorage.removeItem('auth_token')

      this.user = null
      this.setRole()
      this.router.push({ name: "signin" })
    },

    setRole(role) {
      if (role) {
        localStorage.setItem(LOGGED_USER_ROLE, role)
        this.role = role
      } else {
        localStorage.removeItem(LOGGED_USER_ROLE)
        this.role = null
      }
    },
  },
})
